<template>
    <div class="form-group col-12 col-lg-12 mb-4 p-0 text-input" v-if="disabledSelect">
        <label class="my-0" :for="'success_'+name">
            <strong v-if="strong_label===true" v-html="labelSingle"></strong>
            <span v-else v-html="labelSingle"></span>
            <button v-if="!isDisabled" :id="'success_'+name" @click="change" class="btn btn-sm" type="button">
                <i :class="classIcon" aria-hidden="true"></i>
            </button>
        </label>
        <br>
        <p v-if="date!==''">{{ date }}</p>
        <p v-else>-</p>
    </div>
    <div class="row" :class="[name === 'send-date' || customId.includes('created-') ? '' : 'mt-1']" v-else-if="!range">
        <div v-if="mode==='date'" class="col-12 mb-2">
            <input type="hidden" :name="name" :value="dateValue">
            <div class="row">
                <div class="col-12 mb-2">
                    <strong v-if="strong_label===true" v-html="labelSingle"></strong>
                    <span v-else v-html="labelSingle"></span>
                    <small v-if="name === 'send-date' || is_required === true"
                           class="text-red">{{ $lang('(wymagane)') }}</small>
                    <label v-if="correct===true">
                        <i class="fa fa-check text-success ml-2" aria-hidden="true"></i>
                        <span class="text-success">{{ $lang('Poprawna odpowiedź') }}</span>
                    </label>
                    <label v-else-if="correct===false">
                        <i class="fa fa-times text-danger ml-2" aria-hidden="true"></i>
                        <span class="text-danger">{{ $lang('Błędna odpowiedź') }}</span>
                    </label>
                    <label :aria-label="ariaSingle" :for="customId">
                        <slot name="singleIcon"></slot>
                    </label>
                </div>
                <div class="col-12">
                    <div class="row">
                        <div v-bind:class="[use_pencil_checkbox ? 'col-8 col-lg-10' : 'col-12', 'm-0']">
                            <b-form-datepicker :start-weekday="1" :id="customId" v-bind="labelsDate" v-model="dateValue"
                                               :locale="locale" :disabled="isDisabled"
                                               :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-calendar fa-lg" aria-hidden="true"></i></div>
                                <div slot="nav-prev-year"><i class="fa fa-angle-double-left fa-lg"
                                                             aria-hidden="true"></i></div>
                                <div slot="nav-prev-month"><i class="fa fa-angle-left fa-lg" aria-hidden="true"></i>
                                </div>
                                <div slot="nav-this-month"><i class="fa fa-circle fa-lg" aria-hidden="true"></i></div>
                                <div slot="nav-next-month"><i class="fa fa-angle-right fa-lg" aria-hidden="true"></i>
                                </div>
                                <div slot="nav-next-year"><i class="fa fa-angle-double-right fa-lg"
                                                             aria-hidden="true"></i></div>
                            </b-form-datepicker>
                        </div>

                        <div class="col-2 col-sm-2 col-md-2 col-lg-1 m-0 p-0" v-if="use_pencil_checkbox === true">
                            <button :id="'success_'+name" @click="change" class="btn btn-outline-secondary"
                                    type="button" :title="$lang('Zapisz')">
                                <i :id="name+'_icon'" :class="classIcon" aria-hidden="true"></i>
                            </button>
                        </div>
                        <div class="col-2 col-sm-2 col-md-2 col-lg-1 m-0 p-0" v-if="use_pencil_checkbox === true">
                            <button type="button" class="btn btn-outline-secondary" :title="$lang('Anuluj')"
                                    @click.prevent="cancelEdit">
                                <i class="fa fa-times" aria-hidden="true"></i>
                            </button>
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div v-if="mode==='time'" class="col-12">
            <input type="hidden" :value="timeValue" :name="name">
            <label class="sr-only" :aria-label="ariaSingle + ' ' + $lang('Zdefiniuj czas')"
                   :for="customId + '-editable'"></label>
            <label class="sr-only" :aria-label="ariaSingle + ' ' + $lang('Wybierz czas')"
                   :for="customId + '-timepicker'"></label>
            <label v-if="labelSingle !== ''">
                <slot name="singleIcon"></slot>
                {{ labelSingle }}
                <small v-if="name === 'send-date' || is_required === true"
                       class="text-red">{{ $lang('(wymagane)') }}</small>
            </label>
            <div class="row timepicker-row">
                <div class="col-8 px-0">
                    <input :id="customId + '-editable'" type="time" :readonly="isInternetExplorer" :required="is_required"
                           class="form-control b-form-timepicker-input" :disabled="isDisabled"
                           :class="{'border-danger':has_error}"
                           :value="singleTimeNoSeconds" @change="updateTime('single', $event.target.value)">

                </div>
                <div class="col-4 px-0">
                    <b-form-timepicker :id="customId + '-timepicker'" v-bind="labelsTime" v-model="timeValue"
                                       :locale="locale" :disabled="isDisabled" :class="{'border-danger':has_error}">
                        <div slot="button-content"><i class="fa fa-clock-o fa-lg" aria-hidden="true"></i></div>
                    </b-form-timepicker>
                </div>
            </div>
        </div>
        <div v-if="mode==='datetime'" class="col-12">
            <div class="row">
                <div class="col-12">
                    <label v-if="labelSingle !== ''">
                        <slot name="singleIcon"></slot>
                        {{ labelSingle }}
                    </label>
                    <span v-if="name === 'send-date' || is_required === true"
                          class="text-red">{{ $lang('(wymagane)') }}</span>
                    <label v-if="correct===true">
                        <i class="fa fa-check text-success ml-2" aria-hidden="true"></i>
                        <span class="text-success">{{ $lang('Poprawna odpowiedź') }}</span>
                    </label>
                    <label v-else-if="correct===false">
                        <i class="fa fa-times text-danger ml-2" aria-hidden="true"></i>
                        <span class="text-danger">{{ $lang('Błędna odpowiedź') }}</span>
                    </label>
                    <label class="sr-only" :aria-label="ariaSingleDatetime[0]"
                           :for="customId + '-datetime_date'"></label>
                    <b-form-datepicker :id="customId + '-datetime_date'" v-bind="labelsDate" v-model="dateValue"
                                       :locale="locale" :start-weekday="1" :class="{'border-danger':has_error}">
                        <div slot="button-content"><i class="fa fa-calendar fa-lg" aria-hidden="true"></i></div>
                    </b-form-datepicker>
                </div>
                <div class="col-12">
                    <label class="sr-only" :aria-label="ariaSingleDatetime[1] + ' ' + $lang('Zdefiniuj czas')"
                           :for="customId + '-editable'"></label>
                    <label class="sr-only" :aria-label="ariaSingleDatetime[1] + ' ' + $lang('Wybierz czas')"
                           :for="customId + '-timepicker'"></label>
                    <div class="row timepicker-row">
                        <div class="col-8 px-0">
                            <input :id="customId + '-editable'" class="form-control b-form-timepicker-input"
                                   :value="dateTimeNoSeconds" :class="{'border-danger':has_error}"
                                   type="time" :required="is_required"
                                   :readonly="isInternetExplorer"
                                   @change="updateTime('singleDatetime', $event.target.value)">
                        </div>
                        <div class="col-4 px-0">
                            <b-form-timepicker :disabled="isDisabled" :id="customId + '-timepicker'" v-bind="labelsTime"
                                               v-model="timeValue" :class="{'border-danger':has_error}"
                                               :locale="locale">
                                <div slot="button-content"><i class="fa fa-clock-o fa-lg" aria-hidden="true"></i></div>
                            </b-form-timepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div v-else class="row" :class="{'mt-1': name !== 'send-date'}">
        <div class="col-12" v-if="mode==='time'">
            <div class="row">
                <div class="col-5">
                    <label class="sr-only" :aria-label="ariaRange[0] + ' ' + $lang('Zdefiniuj czas')"
                           :for="customId + '-min-time-editable'"></label>
                    <label class="sr-only" :aria-label="ariaRange[0] + ' ' + $lang('Wybierz czas')"
                           :for="customId + '-min-time-timepicker'"></label>
                    <label v-if="labelRange[0] !== ''">
                        <slot name="fromIcon"></slot>
                        {{ labelRange[0] }}
                    </label>
                    <div class="row timepicker-row">
                        <div class="col-8 px-0">
                            <input :id="customId + '-min-time-editable'"
                                   class="form-control b-form-timepicker-input"
                                   type="time" :required="is_required" :name="name"
                                   :readonly="isInternetExplorer"
                                   :value="timeRangeMinNoSeconds"
                                   :disabled="isDisabled"
                                   @change="updateTime('rangeMin', $event.target.value)"
                                   :class="{'border-danger':has_error}">

                        </div>
                        <div class="col-4 px-0">
                            <b-form-timepicker :id="customId + '-min-time-timepicker'" v-bind="labelsTime"
                                               v-model="rangeValues.timeValue.min" :disabled="isDisabled"
                                               :locale="locale" :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-clock-o fa-lg"
                                                              aria-hidden="true"></i></div>
                            </b-form-timepicker>
                        </div>

                    </div>
                </div>
                <div class="offset-2 col-5">
                    <label class="sr-only" :aria-label="ariaRange[1] + ' ' + $lang('Zdefiniuj czas')"
                           :for="customId + '-max-time-editable'"></label>
                    <label class="sr-only" :aria-label="ariaRange[1] + ' ' + $lang('Wybierz czas')"
                           :for="customId + '-max-time-timepicker'"></label>
                    <label v-if="labelRange[1] !== ''">
                        <slot name="toIcon"></slot>
                        {{ labelRange[1] }}
                    </label>
                    <div class="row timepicker-row">
                        <div class="col-8 px-0">
                            <input :id="customId + '-max-time-editable'"
                                   type="time" :required="is_required"
                                   :readonly="isInternetExplorer"
                                   class="form-control b-form-timepicker-input"
                                   :value="timeRangeMaxNoSeconds"
                                   @change="updateTime('rangeMax', $event.target.value)"
                                   :class="{'border-danger':has_error}">

                        </div>
                        <div class="col-4 px-0">
                            <b-form-timepicker :id="customId + '-max-time-timepicker'" v-bind="labelsTime"
                                               v-model="rangeValues.timeValue.max"
                                               :locale="locale" :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-clock-o fa-lg"
                                                              aria-hidden="true"></i></div>
                            </b-form-timepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" v-else-if="mode==='date'">
            <div class="row">
                <div class="col-5">
                    <div class="row">
                        <div v-if="labelRange[0] !== ''" class="col-12">
                            <label :aria-label="ariaRange[0]"
                                   :for="customId + 'date_range_min'">
                                <slot name="fromIcon"></slot>
                                {{ labelRange[0] }}
                            </label>
                        </div>
                        <div class="col-12">
                            <b-form-datepicker :id="customId + 'date_range_min'" v-bind="labelsDate"
                                               v-model="rangeValues.dateValue.min" :locale="locale"
                                               :start-weekday="1" :disabled="isDisabled"
                                               :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-calendar fa-lg" aria-hidden="true"></i></div>
                            </b-form-datepicker>
                        </div>
                    </div>
                </div>
                <div class="col-5 offset-2">
                    <div class="row">
                        <div class="col-12" v-if="labelRange[1] !== ''">
                            <label :aria-label="ariaRange[1]"
                                   :for="customId + 'date_range_max'">
                                <slot name="toIcon"></slot>
                                {{ labelRange[1] }}
                            </label>
                        </div>
                        <div class="col-12">
                            <b-form-datepicker :id="customId + 'date_range_max'" v-bind="labelsDate"
                                               v-model="rangeValues.dateValue.max" :locale="locale"
                                               :start-weekday="1" :disabled="isDisabled"
                                               :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-calendar fa-lg" aria-hidden="true"></i></div>
                            </b-form-datepicker>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12" v-else-if="mode==='datetime'">
            <div class="row">
                <div class="col-5">
                    <div class="row">
                        <div class="col-12">
                            <label v-if="labelRange[0] !== ''">
                                <slot name="fromIcon"></slot>
                                {{ labelRange[0] }}
                            </label>
                            <label v-if="ariaRangeDatetime[0][0]" class="sr-only"
                                   :for="customId + 'datetime_range_min_date'">{{ ariaRangeDatetime[0][0] }}</label>
                        </div>
                        <div class="col-12">
                            <b-form-datepicker :id="customId + 'datetime_range_min_date'" v-bind="labelsDate"
                                               v-model="rangeValues.dateTimeValue.min.date" :locale="locale"
                                               :start-weekday="1" :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-calendar fa-lg" aria-hidden="true"></i></div>
                            </b-form-datepicker>
                        </div>
                        <div class="col-12">
                            <div class="row timepicker-row">
                                <label v-if="ariaRangeDatetime[0][1]" class="sr-only"
                                       :for="customId + 'datetime_range_min_time-picker'">{{ ariaRangeDatetime[0][1] }}
                                    {{ $lang('Wybierz czas') }}</label>
                                <label v-if="ariaRangeDatetime[0][1]" class="sr-only"
                                       :for="customId + 'datetime_range_min_time-editable'">{{ ariaRangeDatetime[0][1] }}
                                    {{ $lang('Zdefiniuj czas') }}</label>
                                <div class="col-8 px-0">
                                    <input :id="customId + 'datetime_range_min_time-editable'"
                                           class="form-control b-form-timepicker-input"
                                           type="time" :required="is_required"
                                           :readonly="isInternetExplorer"
                                           :value="datetimeRangeMinNoSeconds"
                                           @change="updateTime('datetimeRangeMin', $event.target.value)"
                                           :class="{'border-danger':has_error}">
                                </div>
                                <div class="col-4 px-0">
                                    <b-form-timepicker :id="customId + 'datetime_range_min_time-picker'"
                                                       v-bind="labelsTime"
                                                       v-model="rangeValues.dateTimeValue.min.time"
                                                       :locale="locale"
                                                       :class="{'border-danger':has_error}">
                                        <div slot="button-content"><i class="fa fa-clock-o fa-lg"
                                                                      aria-hidden="true"></i></div>
                                    </b-form-timepicker>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="col-5">
                    <div class="row">
                        <div class="col-12">
                            <label v-if="labelRange[1] !== ''">
                                <slot name="toIcon"></slot>
                                {{ labelRange[1] }}
                            </label>
                            <label v-if="ariaRangeDatetime[1][0]" class="sr-only"
                                   :for="customId + 'datetime_range_max_date'">{{ ariaRangeDatetime[1][0] }}</label>
                        </div>
                        <div class="col-12">
                            <b-form-datepicker :id="customId + 'datetime_range_max_date'" v-bind="labelsDate"
                                               v-model="rangeValues.dateTimeValue.max.date" :locale="locale"
                                               :start-weekday="1" :class="{'border-danger':has_error}">
                                <div slot="button-content"><i class="fa fa-calendar fa-lg" aria-hidden="true"></i></div>
                            </b-form-datepicker>
                        </div>
                        <div class="col-12">
                            <div class="row timepicker-row">
                                <label v-if="ariaRangeDatetime[1][1]" class="sr-only"
                                       :for="customId + 'datetime_range_max_time-picker'">{{ ariaRangeDatetime[1][1] }}
                                    {{ $lang('Wybierz czas') }}</label>
                                <label v-if="ariaRangeDatetime[1][1]" class="sr-only"
                                       :for="customId + 'datetime_range_max_time-editable'">{{ ariaRangeDatetime[1][1] }}
                                    {{ $lang('Zdefiniuj czas') }}</label>
                                <div class="col-8 px-0">
                                    <input :id="customId + 'datetime_range_max_time-editable'"
                                           class="form-control b-form-timepicker-input"
                                           type="time" :required="is_required"
                                           :readonly="isInternetExplorer"
                                           :value="datetimeRangeMaxNoSeconds"
                                           @change="updateTime('datetimeRangeMax', $event.target.value)"
                                           :class="{'border-danger':has_error}">
                                </div>
                                <div class="col-4 px-0">
                                    <b-form-timepicker :id="customId + 'datetime_range_max_time-picker'"
                                                       v-bind="labelsTime"
                                                       v-model="rangeValues.dateTimeValue.max.time"
                                                       :locale="locale"
                                                       :class="{'border-danger':has_error}">
                                        <div slot="button-content"><i class="fa fa-clock-o fa-lg"
                                                                      aria-hidden="true"></i></div>
                                    </b-form-timepicker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import {BFormDatepicker} from 'bootstrap-vue';
import {BFormTimepicker} from 'bootstrap-vue';
import 'bootstrap-vue/dist/bootstrap-vue.css'
import ShowNotification from "../mixins/show-notification";
import {EventBus} from "../mixins/event-bus";

export default {
    name: "datepicker-accessible",
    components: {BFormDatepicker, BFormTimepicker},
    mixins: [ShowNotification],
    props: {
        name: String,
        is_required: Boolean,
        value: {type: Array | String, default: '-'},
        valueFormatted: {type: Array | String, default: '-'},
        locale: {type: String, default: 'pl'},
        mode: {type: String, default: 'date'}, //time, date, datetime
        range: {type: Boolean, default: false},
        customId: {type: String, default: 'bp-datepicker-'},
        ariaSingle: {type: String, default: ''},
        ariaSingleDatetime: {
            type: Array, default: function () {
                return ['', '']
            }
        },
        ariaRange: {
            type: Array, default: function () {
                return [this.$lang('Początek') + ':', this.$lang('Koniec') + ':']; //[date, time]
            }
        },
        ariaRangeDatetime: {
            type: Array, default: function () {
                return [['', ''], ['', '']]; //[[from_date, from_time],[to_date, to_time]]
            }
        },
        labelSingle: {type: String, default: ''},
        labelRange: {
            type: Array, default: function () {
                return [this.$lang('Początek') + ':', this.$lang('Koniec') + ':'];
            }
        },
        url: {type: String},
        use_pencil_checkbox: {type: Boolean, default: true},
        strong_label: {type: Boolean, default: true},
        disable: {type: Boolean, default: false},
        correct: {type: Boolean | null, default: null},
        has_error: {type: Boolean, required: false, default: false},
    },
    data: function () {
        return {
            date: this.valueFormatted,
            dateValue: '',
            timeValue: '',
            rangeValues: {
                dateValue: {min: '', max: ''},
                timeValue: {min: '', max: ''},
                dateTimeValue: {min: {date: '', time: ''}, max: {date: '', time: ''}},
            },
            labelsDate: {
                labelPrevYear: this.$lang('Rok wstecz'),
                labelPrevMonth: this.$lang('Miesiąc wstecz'),
                labelCurrentMonth: this.$lang('Aktualny miesiąc'),
                labelNextMonth: this.$lang('Następny miesiąc'),
                labelNextYear: this.$lang('Następny rok'),
                labelToday: this.$lang('Dzisiaj'),
                labelSelected: '',
                labelNoDateSelected: '',
                labelCalendar: this.$lang('Kalendarz'),
                labelNav: '',
                labelHelp: ''
            },
            labelsTime: {
                labelHours: this.$lang('Godziny'),
                labelMinutes: this.$lang('Minuty'),
                labelSeconds: this.$lang('Sekundy'),
                labelIncrement: this.$lang('Zwiększ'),
                labelDecrement: this.$lang('Zmniejsz'),
                labelSelected: '',
                labelNoTimeSelected: '',
                labelCloseButton: this.$lang('Zamknij'),
            },
            classIcon: "fa fa-pencil",
            disabledSelect: this.use_pencil_checkbox,
            isDisabled: false
        }
    },
    watch: {
        dateValue: function () {
            this.$emit('input', this.getValueDependsOnMode());
        },
        timeValue: function () {
            this.$emit('input', this.getValueDependsOnMode());
        },
        rangeValues: {
            handler(val) {
                this.$emit('input', this.getValueDependsOnMode());
            },
            deep: true
        },
        value: function () {
            this.getDateFromValue();
        },
    },
    computed: {
        isInternetExplorer: function () {
            let ua = window.navigator.userAgent;
            let msie = ua.indexOf("MSIE ");
            let trident = ua.indexOf('Trident/'); //IE 11
            let edge = ua.indexOf('Edge');

            return msie > 0 || trident > 0 || edge > 0;
        },
        dateRange: function () {
            return [this.rangeValues.dateValue.min, this.rangeValues.dateValue.max];
        },
        timeRange: function () {
            return [this.normalizeTime(this.rangeValues.timeValue.min), this.normalizeTime(this.rangeValues.timeValue.max)];
        },
        dateTimeRange: function () {
            return [this.rangeValues.dateTimeValue.min.date + 'T' + this.normalizeTime(this.rangeValues.dateTimeValue.min.time),
                    this.rangeValues.dateTimeValue.max.date + 'T' + this.normalizeTime(this.rangeValues.dateTimeValue.max.time)];
        },
        singleTimeNoSeconds: function () {
            return this.cutSeconds(this.timeValue);
        },
        dateTimeNoSeconds: function () {
            return this.cutSeconds(this.timeValue);
        },
        timeRangeMinNoSeconds: function () {
            return this.cutSeconds(this.rangeValues.timeValue.min);
        },
        timeRangeMaxNoSeconds: function () {
            return this.cutSeconds(this.rangeValues.timeValue.max);
        },
        datetimeRangeMaxNoSeconds: function () {
            return this.cutSeconds(this.rangeValues.dateTimeValue.max.time);
        },
        datetimeRangeMinNoSeconds: function () {
            return this.cutSeconds(this.rangeValues.dateTimeValue.min.time);
        }
    },
    methods: {
        cancelEdit() {
            this.disabledSelect = true;
            this.dateValue = this.value;
            this.classIcon = "fa fa-pencil";
        },
        cutSeconds: function (time) {
            let parts = time.split(':');
            if (parts.length === 3) {
                parts.pop();
            }

            return parts.join(':');
        },
        getValueDependsOnMode: function () {
            switch (this.mode) {
                case 'date':
                    if (!this.range) {
                        return this.dateValue;
                    } else {
                        return this.dateRange;
                    }
                case 'time':
                    if (!this.range) {
                        return this.normalizeTime(this.timeValue);
                    } else {
                        return this.timeRange;
                    }
                default:
                    if (!this.range) {
                        return this.dateValue + 'T' + this.normalizeTime(this.timeValue);
                    } else {
                        return this.dateTimeRange;
                    }

            }
        },
        normalizeTime: function (time) {
            if (time !== '' && time !== undefined) {
                let parts = time.split(':');
                if (parts.length === 2) {
                    parts.push('00');
                }

                return parts.join(':');
            } else {
                return time;
            }

        },
        updateTime: function (type, val) {
            switch (type) {
                case 'single':
                case 'singleDatetime':
                    this.timeValue = val;
                    break;
                case 'rangeMin':
                    this.rangeValues.timeValue.min = val;
                    break;
                case 'rangeMax':
                    this.rangeValues.timeValue.max = val;
                    break;
                case 'datetimeRangeMin':
                    this.rangeValues.dateTimeValue.min.time = val;
                    break;
                case 'datetimeRangeMax':
                    this.rangeValues.dateTimeValue.max.time = val;
                    break;

            }
        },
        change() {
            const inpt = $('#' + this.name + '__value_');
            if (this.disabledSelect) {
                this.disabledSelect = false;
                this.classIcon = "fa fa-check";
            } else if (!this.disabledSelect) {
                var data = {};
                data[this.name] = this.dateValue;
                axios.post(this.url, data)
                     .then((response) => {
                         this.successRequest();
                         this.showNotification('success', 'Zapisano');
                     })
                     .catch(function (error) {
                         console.log(error);
                     });
                this.disabledSelect = true;
                this.classIcon = "fa fa-pencil";
            }
        },
        getDateFormatted() {
            var data = {};
            data['date'] = this.dateValue;
            axios.post('task/get-date-formatted', data)
                 .then((response) => {
                     this.date = response.data;
                 })
                 .catch(function (error) {
                     console.log(error);
                 });
        },
        successRequest() {
            this.getDateFormatted();
            var $el = $('#success_' + this.name),
                x = 4000,
                originalBgColor = $el.css("background"),
                originalFontColor = $el.css("color");
            $el.css("transition", "background-color 0.5s ease");
            $el.css("transition", "color 0.5s ease");
            $el.css("background", "var(--primary-to-yellow)");
            $el.css("color", "var(--white-to-black)");

            setTimeout(function () {
                $el.css("transition", "background-color 0.5s ease");
                $el.css("transition", "color 0.5s ease");
                $el.css("background", originalBgColor);
                $el.css("color", originalFontColor);
            }, x);
        },
        getDateFromValue() {
            switch (this.mode) {
                case 'date':
                    if (!this.range) {
                        this.dateValue = this.value;
                    } else {
                        this.rangeValues.dateValue.min = this.value[0];
                        this.rangeValues.dateValue.max = this.value[1];

                    }
                    break;
                case 'time':
                    if (!this.range) {
                        this.timeValue = this.value;
                    } else {
                        this.rangeValues.timeValue.min = this.value[0];
                        this.rangeValues.timeValue.max = this.value[1];

                    }
                    this.timeValue = this.value;
                    break;
                default:
                    if (!this.range) {
                        let datetime = this.value.split('T');
                        this.dateValue = datetime[0];
                        this.timeValue = datetime[1];

                    } else {
                        let min = this.value[0];
                        let max = this.value[1];
                        this.rangeValues.dateTimeValue.min.date = min.split('T')[0];
                        this.rangeValues.dateTimeValue.min.time = min.split('T')[1];
                        this.rangeValues.dateTimeValue.max.date = max.split('T')[0];
                        this.rangeValues.dateTimeValue.max.time = max.split('T')[1];

                    }
            }
        }
    },
    created() {
        if (this.value !== [] && this.value !== '-') {
            this.getDateFromValue();
        }
        EventBus.$on('fixedFiltersDisabled', (result) => {
            this.isDisabled = result.disabled;
        });
        this.isDisabled = this.disable;

    },
    mounted() {
        jQuery('.b-form-timepicker').find('label').hide();

        if (!this.range) {
            if (this.mode === 'date') {
                jQuery('#' + this.customId).attr('aria-label', this.ariaSingle);
            }
            if (this.mode === 'time') {
                jQuery('#' + this.customId + '-timepicker').attr('aria-label', this.ariaSingle + ' ' + this.$lang('Wybierz czas'));
            }
            if (this.mode === 'datetime') {
                jQuery('#' + this.customId + '-datetime_date').attr('aria-label', this.ariaSingleDatetime[0]);
                jQuery('#' + this.customId + '-timepicker').attr('aria-label', this.ariaSingleDatetime[1] + ' ' + this.$lang('Wybierz czas'));
            }
        } else {
            if (this.mode === 'time') {
                jQuery('#' + this.customId + '-min-time-timepicker').attr('aria-label', this.ariaRange[0] + ' ' + this.$lang('Wybierz czas'));
                jQuery('#' + this.customId + '-max-time-timepicker').attr('aria-label', this.ariaRange[1] + ' ' + this.$lang('Wybierz czas'));
            }
            if (this.mode === 'time') {
                jQuery('#' + this.customId + 'date_range_min').attr('aria-label', this.ariaRange[0]);
                jQuery('#' + this.customId + 'date_range_max').attr('aria-label', this.ariaRange[1]);
            }
            if (this.mode === 'datetime') {
                jQuery('#' + this.customId + 'datetime_range_min_date').attr('aria-label', this.ariaRangeDatetime[0][0]);
                jQuery('#' + this.customId + 'datetime_range_max_date').attr('aria-label', this.ariaRangeDatetime[1][0]);
                jQuery('#' + this.customId + 'datetime_range_min_time-picker').attr('aria-label', this.ariaRangeDatetime[0][1]);
                jQuery('#' + this.customId + 'datetime_range_max_time-picker').attr('aria-label', this.ariaRangeDatetime[1][1]);
            }
        }
    }
}
</script>
